import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'
import * as rd from "diacritics"

import {
  Table,
  Glyphicon,
  Well,
  Button,
} from 'react-bootstrap';

import If from "../../utils/If"

import Loader from 'react-loader-advanced';

import '../../statics/css/table-training.css'

import videoPlayerIcon from '../../statics/images/video_player.svg'

//DAO
import { trainingList } from '../../dao-firebase/training-daofirebae'

class TableTrainings extends Component {

  constructor(props) {
    super(props);

    this.state = {

      trainings: [],

      //modal select training
      //selected_training_modal: undefined,
    };

  }

  componentDidMount() {

  }

  componentWillMount() {
    trainingList(JSON.parse(localStorage.getItem("USER")).uid, (response) => {

      //console.table(this.state.trainings)

      this.setState({
        trainings: response,
      }, () => {

        //console.log(this.state.trainings)
      })
    })
  }

  convertDate(date) {

    let convertedDate = new Date(date * 1000).toLocaleDateString("pt-BR");

    return convertedDate;
  }

  trainingDetail(training) {

    this.props.handleDetailTraining(training);

    //this.props.history.push("/treino/montar");
  }

  verifySearch(obj) {

    let nameObjFormat = rd.remove(obj.name.toLowerCase());
    let searchFormat = rd.remove(this.props.search.toLowerCase());
    return nameObjFormat.includes(searchFormat);
  }

  handleDetailTrainingModal(training) {

    this.props.handleDetailTrainingModal(training);
  }

  selectTrainingModal(training) {

    this.props.handleSelectTrainingModal(training)
  }

  renderTrainings() {

    return _.map(this.state.trainings, (training) => {

      return (

        // <li className="card-training">
        //   <p className="training-name">{training.data.name}</p>
        // </li>

        <If test={(this.props.search && this.props.search != '' && this.verifySearch(training.data)) || this.props.search == undefined || this.props.search == ''}>

          <tr onClick={this.props.handleDetailTrainingModal ? () => this.selectTrainingModal(training) : null} className={`item-trainings-list ${(this.props.selectedTrainingModal && this.props.selectedTrainingModal.id == training.id) ? 'active-select-training' : ''}`}>

            <td className="training-name middle-td">
              <p>{training.data.name}</p>

            </td>

            <td className="training-description middle-td">
              <p>{training.data.description.toString().length > 200 ?
                (training.data.description.toString().substring(0, 200) + "...")
                :
                training.data.description.toString()}</p>
            </td>

            <td className="training-date text-center middle-td">
              <p>{training.data.date_create ?
                this.convertDate(training.data.date_create.seconds)
                :
                ""}</p>
            </td>

            <td className="middle-td text-center">
              <Button bsStyle="success" onClick={
                this.props.handleDetailTrainingModal ?
                  () => this.handleDetailTrainingModal(training)
                  :
                  () => this.trainingDetail(training)

              }>Detalhar</Button>
            </td>

          </tr>
        </If >

      )
    })
  }

  render() {

    return (
      <div className="table-training">

        {/* <ul className="ul-training-list">
          {this.renderTrainings()}


        </ul> */}

        <Well>
          <Table responsive>
            <thead>
              <tr>
                <th>Título</th>
                <th>Descrição</th>
                <th className="text-center">Criação</th>
                <th className="text-center">Ações</th>
              </tr>
            </thead>
            <tbody>
              {this.renderTrainings()}
            </tbody>
          </Table>
        </Well>
      </div >
    );
  }
}

export default TableTrainings;



// WEBPACK FOOTER //
// src/components/treinos/table-trainings.js